export function normalizeCampaignType(type) {
  const raw = String(type || '').toLowerCase();
  if (raw.includes('brand') || raw === 'sb') return 'sponsored_brands';
  if (raw.includes('display') || raw === 'sd') return 'sponsored_display';
  if (raw.includes('product') || raw === 'sp' || raw === 'sponsored_products') return 'sponsored_products';
  return '';
}

export function isSponsoredBrands(type) {
  return normalizeCampaignType(type) === 'sponsored_brands';
}

export function isSponsoredDisplay(type) {
  return normalizeCampaignType(type) === 'sponsored_display';
}

export function parseCampaignsPayload(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.campaigns)) return payload.campaigns;
  return [];
}

export function findCampaignById(campaigns, campaignId) {
  const wanted = String(campaignId);
  return (campaigns || []).find((campaign) => {
    return String(campaign.campaignId || campaign.id || '') === wanted;
  }) || null;
}
